<template>
  <header class="app-header">
    <base-loader v-if="dataIsLoading" />
    <div class="header-block" v-else>
      <div class="header-left">
        <div class="burger-menu" @click="$emit('toggle-mobile-menu')">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3 12H21M3 6H21M3 18H21"
              stroke="#1e1e2f"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>

        <CompanySwitcher
          class="company-switcher"
          :current-company-name="companyName"
          :companies="availableCompanies"
          :current-company-id="currentCompanyId"
          @company-switch="switchCompany"
        />
      </div>

      <ul class="nav-list">
        <li v-if="currentCompanyId" class="nav-item">
          <NotificationBell />
        </li>
        <li class="nav-item desktop-only">
          <BaseDropdownButton
            :trigger-text="userInitials"
            :items="dropdownItems"
          />
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
import { mapState, mapActions } from "pinia";

import CompanySwitcher from "@/components/CompanySwitcher.vue";
import NotificationBell from "@/components/Notification/Bell.vue";

import { useUserDataStore } from "@/stores/userDataStore";
import { useAuthStore } from "@/stores/authStore";

export default {
  name: "AppHeader",
  components: {
    CompanySwitcher,
    NotificationBell,
  },
  computed: {
    dataIsLoading() {
      return useUserDataStore().isSwitchingCompany;
    },
    ...mapState(useUserDataStore, {
      userInitials: "initials",
      companies: "companies",
      currentCompany: "currentCompany",
    }),

    currentCompanyId() {
      return this.currentCompany?.id || "";
    },

    availableCompanies() {
      return this.companies || [];
    },

    companyName() {
      return this.currentCompany?.name || "Название компании";
    },

    dropdownItems() {
      return [
        {
          id: "settings",
          label: "Профиль",
          action: this.goToUserProfile,
        },
        {
          id: "logout",
          label: "Выход",
          isDanger: true,
          action: this.logout,
        },
      ];
    },
  },
  methods: {
    ...mapActions(useAuthStore, { authLogout: "logout" }),

    async switchCompany(company) {
      if (await useUserDataStore().switchCompany(company.id)) {
        window.location.assign(this.$router.resolve({ name: "Home" }).href);
      }
    },

    goToUserProfile() {
      this.$router.push({ name: "UserProfile" });
    },

    logout() {
      this.authLogout();
      this.$router.push({ name: "Login" });
    },
  },
};
</script>

<style scoped>
.app-header {
  height: 100px;
  background-color: var(--color-light);
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

.header-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 30px;
  gap: 15px;
}

.header-left {
  display: flex;
  flex: 1;
  align-items: center;
  gap: 15px;
  min-width: 0;
}

.burger-menu {
  display: none;
  cursor: pointer;
  padding: 5px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.burger-menu:hover {
  background-color: #f0f0f0;
}

.nav-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  min-width: 170px;
  gap: 12px;
  flex-shrink: 0;
}

.nav-item {
  margin: 0;
}

@media (max-width: 1024px) {
  .burger-menu {
    display: block;
  }

  .header-left {
    gap: 15px;
    width: 100%;
    justify-content: space-between;
  }

  .nav-list {
    min-width: 0;
  }

  .desktop-only {
    display: none;
  }
}

@media (max-width: 768px) {

  .app-header {
    height: 70px;
  }

  .header-block {
    padding: 0 15px;
  }
}
</style>
